module.exports = __webpack_public_path__ + "49f9390e43c32be2d91ec27ff064abfc.glb";